export default "__VITE_ASSET__CiD$6vBY__"